import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black border-t border-[#F97316]/20 py-10 px-4" data-id="element-249">
      <div className="max-w-3xl mx-auto text-center" data-id="element-250">
        <div className="text-[#F97316] text-2xl font-black tracking-widest mb-4" data-id="element-251">
          🥊 PROFEPACK™
        </div>
        <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-252">
          El sistema de clases N°1 para entrenadores de boxeo en habla hispana.
        </p>
        <p className="text-gray-400 text-sm italic mb-6" data-id="element-253">
          Porque enseñar boxeo no debería costarte todas las noches de la
          semana.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-300 mb-6" data-id="element-254">
          <span data-id="element-255">📧 soporteprofepack@gmail.com</span>
          <span className="hidden sm:inline" data-id="element-256">•</span>
          <span data-id="element-257">📲 @profepack</span>
          <span className="hidden sm:inline" data-id="element-258">•</span>
          <span data-id="element-259">🌐 profepack.com</span>
        </div>

        <div className="h-px bg-[#F97316]/20 mb-6" data-id="element-260" />
        <p className="text-gray-400 text-xs mb-2" data-id="element-261">
          © ProfePack™ 2026 — Todos los derechos reservados.
        </p>
        <p className="text-gray-500 text-xs mb-6" data-id="element-262">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}